/*
  MacShack bag (drawer + /cart page).
  - Quantity, remove (a device takes its add-ons with it), add an offered warranty.
  - Re-renders the drawer, the header bag icon and the bag page through the Section Rendering API.
  - Shipping protection: one switch (off by default) and one Check out button. SimplyInsurance's own
    widget stays on the page, hidden; Check out clicks its "with protection" or "without" option, so
    the app adds its product exactly as before. Without the widget, Check out goes to /checkout.
  - Shows "Added to your bag." when the drawer opens after an add.
*/
(function () {
  if (window.__msBag) return;
  window.__msBag = true;

  var STORE = 'msb-protect';
  function getPref() { try { return sessionStorage.getItem(STORE); } catch (e) { return null; } }
  function setPref(v) { try { sessionStorage.setItem(STORE, v ? '1' : '0'); } catch (e) {} }

  function prefixOf(el) {
    var r = el && el.closest('[data-money-prefix]');
    return (r && r.getAttribute('data-money-prefix')) || 'R ';
  }
  function money(cents, prefix) {
    var n = Math.round(cents) / 100, whole = Math.floor(n), frac = Math.round((n - whole) * 100);
    var s = whole.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    if (frac) s += '.' + (frac < 10 ? '0' : '') + frac;
    return prefix + s;
  }
  function parseCents(text) {
    var m = (text || '').replace(/[^0-9.,]/g, '').replace(/,/g, '');
    var n = parseFloat(m);
    return isNaN(n) ? 0 : Math.round(n * 100);
  }

  function pageRoot() { return document.querySelector('[data-bag-page]'); }
  function sectionsFor() {
    var s = ['header-mini-cart-content', 'header-mini-cart-footer', 'ms-header-bag'];
    var page = pageRoot();
    if (page) s.push(page.getAttribute('data-section-id'));
    return s;
  }
  function parse(html) { return new DOMParser().parseFromString(html, 'text/html'); }

  /* Put fresh section HTML in place. */
  function apply(sections) {
    if (!sections) return;
    var c = sections['header-mini-cart-content'], f = sections['header-mini-cart-footer'], h = sections['ms-header-bag'] || sections.header;
    var content = document.getElementById('header-mini-cart-content');
    var footer = document.getElementById('header-mini-cart-footer');
    if (c && content) { var dc = parse(c).querySelector('.shopify-section'); if (dc) content.innerHTML = dc.innerHTML; }
    if (f && footer) { var df = parse(f).querySelector('.shopify-section'); if (df) footer.innerHTML = df.innerHTML; }
    if (h) {
      var src = parse(h).querySelector('.head-slot-cart-link'), dst = document.querySelector('.head-slot-cart-link');
      if (src && dst) dst.innerHTML = src.innerHTML;
    }
    var page = pageRoot();
    if (page) {
      var ps = sections[page.getAttribute('data-section-id')];
      var root = page.querySelector('[data-bag-root]');
      if (ps && root) {
        var doc = parse(ps);
        var dp = doc.querySelector('[data-bag-root]');
        if (dp) root.innerHTML = dp.innerHTML;
        syncSetup(page, doc);
      }
    }
    refresh();
  }

  /* "Complete your setup" sits outside the re-rendered part so loaded cards stay put. Keep it
     in step with the bag: gone when the bag is empty, rebuilt when the main device changes. */
  function sig(el) {
    return el ? [el.getAttribute('data-pid'), el.getAttribute('data-model'), el.getAttribute('data-family')].join('|') : '';
  }
  function syncSetup(page, doc) {
    var cur = page.querySelector('.msb-setup');
    var next = doc.querySelector('.msb-setup');
    if (!next) { if (cur) cur.remove(); return; }
    if (cur && sig(cur) === sig(next)) {
      cur.setAttribute('data-exclude', next.getAttribute('data-exclude') || '');
      return;
    }
    var fresh = document.importNode(next, true);
    if (cur) cur.replaceWith(fresh); else page.appendChild(fresh);
    if (window.msAddonsInit) window.msAddonsInit();
  }

  function post(url, body, withSections) {
    if (withSections !== false) {
      body.sections = sectionsFor();
      body.sections_url = window.location.pathname;
    }
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status) throw new Error(res.description || res.message || 'Something went wrong. Please try again.');
      return res;
    });
  }

  function busy(el, on) {
    var root = el && el.closest && el.closest('.msb');
    if (root) root.classList.toggle('is-busy', on);
  }
  function showError(el, msg) {
    var root = el && el.closest && el.closest('.msb');
    var box = root && (root.querySelector('[data-bag-error]') || root.querySelector('.msb-error'));
    if (box) box.textContent = msg;
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  /* The key on the page can be out of date (the bag changed in another tab, an app edited it,
     or Shopify re-keyed a line). Find the line in the current cart: same key, else the only
     line with the same variant. */
  function resolveKey(items, key) {
    for (var i = 0; i < items.length; i++) if (items[i].key === key) return key;
    var vid = String(key).split(':')[0];
    var same = items.filter(function (it) { return String(it.variant_id) === vid; });
    return same.length === 1 ? same[0].key : null;
  }

  /* updates: [{ key, qty }] in order. kidsOf: a device's variant id; its add-ons (lines whose
     _for names it) are removed first, read from the current cart rather than the page. */
  function update(el, updates, kind, kidsOf) {
    // Keep the static root: el itself is replaced by the re-render.
    var root = el.closest('.msb');
    busy(root, true);
    showError(root, '');
    // One /cart/change.js call per line (not /cart/update.js): Shopify's analytics only report
    // remove_from_cart for change calls.
    var url = (window.routes && window.routes.cart_change_url ? window.routes.cart_change_url : '/cart/change') + '.js';
    var last = null;
    return getCart()
      .then(function (cart) {
        var items = cart.items || [];
        var todo = [];
        if (kidsOf) {
          items.forEach(function (it) {
            if (it.properties && String(it.properties._for) === String(kidsOf)) todo.push({ key: it.key, qty: 0, vid: it.variant_id });
          });
        }
        updates.forEach(function (u) {
          var k = resolveKey(items, u.key);
          if (k && !todo.some(function (t) { return t.key === k; })) todo.push({ key: k, qty: u.qty });
        });
        var chain = Promise.resolve();
        todo.forEach(function (t, i) {
          chain = chain.then(function () {
            return post(url, { id: t.key, quantity: t.qty }, i === todo.length - 1).then(function (res) { last = res; });
          });
        });
        return chain;
      })
      .then(function () {
        if (last && last.sections) apply(last.sections); else return reload();
        document.dispatchEvent(new CustomEvent(kind === 'remove' ? 'cart:item-remove' : 'cart:item-quantity-update', { detail: { cart: last, context: 'MsBag' } }));
      })
      .catch(function (e) {
        // Show the bag as it really is now, then the message.
        return reload().then(function () { showError(root, e.message || 'Something went wrong. Please try again.'); });
      })
      .finally(function () { busy(root, false); });
  }

  function add(el, items) {
    var root = el.closest('.msb');
    el.classList.add('is-loading');
    busy(root, true);
    showError(root, '');
    return post((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', { items: items })
      .then(function (res) {
        apply(res.sections);
        document.dispatchEvent(new CustomEvent('cart:item-add', { detail: { items: res.items || [res], context: 'MsBag' } }));
      })
      .catch(function (e) { showError(root, e.message || 'Something went wrong. Please try again.'); })
      .finally(function () { el.classList.remove('is-loading'); busy(root, false); });
  }

  /* ---------- Shipping protection + totals ---------- */
  function protOn(pay) {
    var inCart = parseInt(pay.getAttribute('data-prot-in-cart'), 10) || 0;
    var pref = getPref();
    if (pref === null) return inCart > 0;
    return pref === '1';
  }

  function siPrice(pay) {
    var el = pay.querySelector('.ssp-checkout-button-container .insurance_plan, .insurance_plan');
    return el ? parseCents(el.textContent) : 0;
  }

  function renderPay(pay) {
    var prefix = prefixOf(pay);
    // The app's own buttons stay hidden from keyboard and screen readers; ours does the work.
    pay.querySelectorAll('.msb-si a, .msb-si button, .msb-si input, .msb-si [tabindex]').forEach(function (n) { n.setAttribute('tabindex', '-1'); });
    var base = parseInt(pay.getAttribute('data-total-base'), 10) || 0;
    var inCart = parseInt(pay.getAttribute('data-prot-in-cart'), 10) || 0;
    var price = inCart || siPrice(pay);
    var row = pay.querySelector('[data-prot]');
    var input = pay.querySelector('[data-prot-input]');
    var hasSi = !!pay.querySelector('.ssp-checkout-button') || inCart > 0;
    var on = protOn(pay);
    if (row) {
      row.hidden = !(hasSi && price > 0);
      if (input) input.checked = on;
      var pp = row.querySelector('[data-prot-price]');
      if (pp) pp.textContent = money(price, prefix);
    }
    var total = base + (on && price > 0 ? price : 0);
    var t = pay.querySelector('[data-total]'); if (t) t.textContent = money(total, prefix);
    var mo = pay.querySelector('[data-mo]'); if (mo) mo.textContent = 'or ' + money(Math.round(total / 12), prefix) + '/mo over 12 months with Mobicred';
    var lbl = pay.querySelector('[data-checkout-label]'); if (lbl) lbl.textContent = 'Check out · ' + money(total, prefix);
    var root = pay.closest('[data-bag-page]');
    if (root) {
      var head = root.querySelector('[data-total-head]'); if (head) head.textContent = money(total, prefix) + '.';
    }
  }

  function watchSi(pay) {
    if (pay.__msbWatch) return;
    pay.__msbWatch = true;
    var box = pay.querySelector('.msb-si');
    if (box && 'MutationObserver' in window) {
      new MutationObserver(function () { renderPay(pay); }).observe(box, { childList: true, subtree: true, characterData: true });
    }
    // The app can be slow to draw; check a few more times.
    [600, 1500, 3000, 6000].forEach(function (ms) { setTimeout(function () { if (pay.isConnected) renderPay(pay); }, ms); });
  }

  /* Fetch fresh sections without changing the cart (e.g. after an add made elsewhere on /cart). */
  var reloading = null;
  function reload() {
    if (reloading) return reloading;
    reloading = fetch(window.location.pathname + '?sections=' + encodeURIComponent(sectionsFor().join(',')))
      .then(function (r) { return r.json(); })
      .then(function (s) { apply(s); })
      .catch(function () {})
      .finally(function () { reloading = null; });
    return reloading;
  }

  /* Only shipping protection left: take it out too. */
  var clearing = false, triedOrphans = null;
  function clearOrphans() {
    var el = document.querySelector('.msb-empty[data-orphans]');
    if (!el || clearing) return;
    var list = el.getAttribute('data-orphans');
    if (list === triedOrphans) return; // tried these already; don't loop
    triedOrphans = list;
    var ups = [];
    list.split(',').forEach(function (k) { if (k) ups.push({ key: k, qty: 0 }); });
    clearing = true;
    update(el, ups, 'remove').finally(function () { clearing = false; });
  }

  function refresh() {
    document.querySelectorAll('[data-bag-pay]').forEach(function (pay) {
      // The app draws its widget when the img loads; a re-render may need a nudge.
      if (window.simplyInsurance && window.simplyInsurance.loadApp && !pay.querySelector('.ssp-checkout-button')) {
        try { window.simplyInsurance.loadApp(); } catch (e) {}
      }
      watchSi(pay);
      renderPay(pay);
    });
    clearOrphans();
    var src = document.querySelector('#header-mini-cart-content [data-bag-count-src]');
    var cnt = document.querySelector('[data-bag-count]');
    if (src && cnt) {
      var n = parseInt(src.getAttribute('data-bag-count-src'), 10) || 0;
      cnt.textContent = n ? n + (n === 1 ? ' item' : ' items') : '';
    }
  }

  function checkout(btn) {
    var root = btn.closest('.msb');
    var pay = root && root.querySelector('[data-bag-pay]');
    var on = pay ? protOn(pay) : false;
    var withBtn = pay && pay.querySelector('.ssp-checkout-button');
    var without = pay && pay.querySelector('.ssp-checkout-link');
    var cta = pay ? pay.querySelector('[data-checkout]') : btn;
    [btn, cta].forEach(function (b) { if (b) b.classList.add('is-loading'); });
    setTimeout(function () { [btn, cta].forEach(function (b) { if (b) b.classList.remove('is-loading'); }); }, 8000);
    if (on && withBtn) { withBtn.click(); return; }
    if (!on && without) { without.click(); return; }
    window.location.href = (window.routes && window.routes.checkout_url) || '/checkout';
  }

  /* ---------- Events ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest || !t.closest('.msb')) return;

    var q = t.closest('[data-qty]');
    if (q) {
      var line = q.closest('[data-key]');
      var cur = parseInt(q.parentNode.getAttribute('data-qty-val'), 10) || 1;
      var next = Math.max(0, cur + parseInt(q.getAttribute('data-qty'), 10));
      var ups = [{ key: line.getAttribute('data-key'), qty: next }];
      // The extended warranty follows its device's quantity.
      if (line.classList.contains('msb-line') && next > 0) {
        line.querySelectorAll('.msb-kid[data-follow]').forEach(function (k) { ups.push({ key: k.getAttribute('data-key'), qty: next }); });
      }
      update(q, ups, next === 0 ? 'remove' : 'qty', next === 0 && line.classList.contains('msb-line') ? String(line.getAttribute('data-key')).split(':')[0] : null);
      return;
    }
    var rm = t.closest('[data-remove]');
    if (rm) {
      var ln = rm.closest('[data-key]');
      var isLine = ln.classList.contains('msb-line');
      var lineKey = ln.getAttribute('data-key');
      update(rm, [{ key: lineKey, qty: 0 }], 'remove', isLine ? String(lineKey).split(':')[0] : null);
      return;
    }
    var ad = t.closest('[data-add]');
    if (ad) {
      add(ad, [{ id: parseInt(ad.getAttribute('data-add'), 10), quantity: parseInt(ad.getAttribute('data-add-qty'), 10) || 1, properties: { _for: ad.getAttribute('data-for') } }]);
      return;
    }
    var co = t.closest('[data-checkout]');
    if (co) { e.preventDefault(); checkout(co); }
  });

  // Capture phase + stopPropagation: the theme's <mini-cart> treats any change inside it as a
  // quantity edit and posts a broken update ("There was an error while updating your cart").
  document.addEventListener('change', function (e) {
    var input = e.target.closest && e.target.closest('[data-prot-input]');
    if (!input) return;
    e.stopPropagation();
    setPref(input.checked);
    document.querySelectorAll('[data-bag-pay]').forEach(renderPay);
  }, true);

  /* "Added to your bag." after an add from a product page */
  document.addEventListener('cart:item-add', function (e) {
    var d = e.detail || {};
    if (d.context === 'MsBag') return;
    // On the bag page an add from "Complete your setup" must show up in the list.
    if (pageRoot()) { reload(); return; }
    var items = (d.items || []).filter(function (i) { return i && i.product_title; });
    var banner = document.querySelector('#header-mini-cart-content [data-bag-added]');
    if (!banner || !items.length) return;
    var main = items.reduce(function (a, b) { return (b.final_line_price || 0) > (a.final_line_price || 0) ? b : a; }, items[0]);
    var name = main.product_title.split(' - ')[0].replace(/\s*\(\d{4}\)\s*$/, '');
    var extra = items.length - 1;
    banner.querySelector('[data-bag-added-text]').textContent = name + (extra > 0 ? ' and ' + extra + (extra === 1 ? ' add-on' : ' add-ons') + '.' : '.');
    banner.hidden = false;
  });

  /* The theme re-renders the drawer after Add to Bag; keep totals and the count in step. */
  function init() {
    var content = document.getElementById('header-mini-cart-content');
    if (content && 'MutationObserver' in window) {
      new MutationObserver(function () { refresh(); }).observe(content, { childList: true });
    }
    refresh();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
